import _ from 'lodash';
import { CLEAR_OFFERS, OFFERS_UPDATED } from '../actions/types';
import { Offer } from '../../1_types/genericTypes';

type OfferReducerState = {
  productOffers: Offer[];
  thresholdOffer: Offer;
};

const INITIAL_STATE: OfferReducerState = {
  productOffers: [],
  thresholdOffer: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case OFFERS_UPDATED:
      return {
        ...state,
        productOffers: _.filter(
          action.payload,
          (offer) => offer.config.products
        ),
        thresholdOffer: _.find(
          action.payload,
          (offer) => offer.config.threshold
        ),
      };
    case CLEAR_OFFERS:
      return INITIAL_STATE;
    default:
      return state;
  }
};
